<template>
  <div
    class="col-span-6 md:col-span-3 border-dashed border-4 w-full text-center align-middle cursor-pointer"
  >
    <div class="flex flex-col h-full justify-center py-5">
      <p class="text-custom-lightblue mb-2">
        Documents for UK Residency
      </p>
      <p class="font-semibold">UPLOAD</p>
    </div>
  </div>
</template>
<script>
export default {};
</script>
